<template>
  <div class="outer-auth-box">
    <div class="auth-box">
      <div class="image-box">
        <img src="/logo.png" alt="myket-logo" />
      </div>
      <div class="text-center">
        <h3 class="my-5 primary--text">เข้าสู่ระบบ</h3>
        <div class="p-2 my-3 text-xs rounded success white--text" v-if="changedStatus">{{ changedStatus }}</div>
        <!-- <p>เข้าสู่ระบบโดยใช้ ชื่อผู้ใช้งานหรือเบอร์โทรศัพท์</p> -->
      </div>

      <v-form @submit.prevent="login" :disabled="isLoggingIn">
        <v-text-field name="username" label="เบอร์โทรศัพท์" placeholder="เบอร์โทรศัพท์" id="Username"
          background-color="grey lighten-4" flat solo v-model="username" @keydown.enter="login"
          prepend-inner-icon="mdi-cellphone"></v-text-field>
        <v-text-field type="password" name="password" placeholder="รหัสผ่าน" label="รหัสผ่าน"
          background-color="grey lighten-4" flat id="Password" solo v-model="password" @keydown.enter="login"
          autocomplete="on" prepend-inner-icon="mdi-lock-outline"></v-text-field>
        <v-btn to="password-recovery" text class="link-forgot">ลืมรหัสผ่าน?</v-btn>
        <v-btn dark elevation="0" color="darkprimary" block class="py-3" large @click="login" :loading="isLoggingIn"
          :disabled="isLoggingIn">เข้าสู่ระบบ</v-btn>
      </v-form>
      <div class="my-3 text-xs text-center">หากยังไม่มีผู้ใช้งาน</div>
      <v-btn dark elevation="0" color="info darken-2" outlined block class="py-3" large link
        to="signup">สมัครสมาชิก</v-btn>
    </div>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง
    </v-snackbar>
    <div class="divider-box">
      <v-divider></v-divider>
      <div class="text">หรือ</div>
      <v-divider></v-divider>
    </div>
    <div class="sso-box">
      เข้าสู่ระบบผ่าน <v-btn color="darkprimary" text @click="gotoSSO()">บัญชีขององค์กร</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  computed: {
    changedStatus() {
      return this.$route.query.isChanged
        ? "เปลี่ยนรหัสผ่านสำเร็จกรุณาเข้าสู่ระบบอีกครั้ง"
        : false;
    }
  },
  created() {
    let sessionToken = this.$route.query?.sessionToken;
    if (sessionToken) {
      localStorage.setItem("sessionToken", sessionToken);
      this.$router.push("/");
    }
  },
  data() {
    return {
      isLoggingIn: false,
      username: "",
      password: "",
      isError: false
    };
  },
  props: {},
  methods: {
    async login() {
      try {
        this.isLoggingIn = true;
        const login = await this.$store.dispatch("user/login", {
          username: this.username,
          password: this.password
        });
        if (login) {
          if (this.$route.query?.redirect) {
            this.$router.push(this.$route.query?.redirect);
          } else {
            this.$router.push("/");
          }
        }
      } catch (err) {
        this.isLoggingIn = false;
        this.isError = true;
      }
    },
    gotoSSO() {
      window.location.replace(process.env.VUE_APP_SSO_URL);
    }
  }
};
</script>

<style lang="scss" scoped>
.outer-auth-box {
  .auth-box {
    .image-box {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 300px;

      img {
        width: 200px;
        height: 100%;
        object-fit: contain;
        object-position: center;
      }
    }

    padding: 50px 40px 30px;
    border-radius: 5px;
    background: #FFFFFF;
    box-shadow: 0px 12px 44px 0px #0000001F;

  }

  .divider-box {
    margin: 25px 0 15px;
    display: flex;
    gap: 25px;
    justify-content: center;
    align-items: center;

    .text {
      // padding: 0 15px;
      font-size: 12px;
      color: var(--v-darkgray-base);
    }
  }

  .sso-box {
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--v-darkgray-base);
    font-size: 14px;

    .v-btn {
      font-size: 14px;
      letter-spacing: unset;
      padding: 0;
      height: unset;
      width: unset;
    }
  }
}

.link-forgot {
  padding: 0 !important;
  height: unset !important;
  min-width: unset !important;
  font-size: 14px !important;
  color: var(--v-info-darken2) !important;
  margin: 0;
  text-transform: unset;
  letter-spacing: unset;
  margin-bottom: 20px;
  float: right;
}

.link-forgot:hover {
  text-decoration: underline;
}

.link-forgot:hover::before {
  opacity: 0 !important;
}
</style>
